export const EVENT_TYPES = {
    DOM_READY: "dom-ready",
    PROMO_CODE: "promo_code",
    BAGGAGE_ALLOWANCE: "baggage-allowance",
    BOOKING_ERROR: "booking_error",
    BOOKING_SUBMIT: "booking_submit",
    PRODUCT_IMPRESSION: "product_impression",
    PRODUCT_IMPRESSION_REFINE: "product_impression_refine",
    PRODUCT_IMPRESSION_LOADMORE: "product_impression_loadmore",
    SEARCH_REFINEMENT: "search_refinement",
    FLIGHT_UPGRADATION: "flight-upgradation",
    PRODUCT_DETAIL_MOBILE: "product_detail_mobile",
    MODAL_POPUP_ERRORS: "modal_popup_errors",
    PRICING_ERROR: "pricingerror",
    SEAT_SELECTION: "seat-selection",
    CART_VIEW: "cart_view",
    UPLIFT_PAYMENT: "uplift-payment",
};

export const DTM_STATUS = {
    SUCCESS: "success",
    FAIL: 'fail'
};


export const TRACKING_DATA = {
    SEARCH: {
        digitalData: {
            path: "Flights",
            page: {
                pageID: 202,
                pageName: "flights:search results",
                pageURL: window.location.href,
                referringURL: document.referrer,
                pageType: "search results",
                language: "en-US",
                platform: "Desktop",
            },
        }
    },
    BOOKING: {
        digitalData: {
            path: "Flights",
            page: {
                pageID: 203,
                pageName: "flights:verify book",
                pageURL: window.location.href,
                referringURL: document.referrer,
                pageType: "verify",
                language: "en-US",
                platform: "Desktop",
            }
        }
    },
    BOOKING_CONFIRMATION: {
        digitalData: {
            path: "Flights",
            page: {
                pageID: 204,
                pageName: "Confirmation",
                pageURL: window.location.href,
                referringURL: document.referrer,
                pageType: "Flight confirmation",
                language: "en-US",
                platform: "Desktop",
            }
        }
    }
}

export const trackEvent = (event, data = {}) => {
    if (window._satellite) {
        window._satellite.track(event, data);
    }
};
